import { ConfigProvider, Divider, message, Modal, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";

function ViewGroupModal({ openModal, records }) {
  const { isLoggedIn, user, restaurantId, restaurantSlug, role } = useUserStore();
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurants, setSelectedRestaurants] = useState([]);

  useEffect(() => {
    // Update selectedRestaurants when records change
    if (records.param?.restaurants) {
      const initialSelection = records.param.restaurants.map((restaurant) => ({
        value: restaurant.restaurantId,
        label: restaurant.restaurantFullName,
      }));
      setSelectedRestaurants(initialSelection);
    }
  }, [records]);

  useEffect(() => {
    fetchRestaurants();
  }, []);

  const fetchRestaurants = async () => {
    const params = {
      restaurantSlug,
      page: 1,
      perPage: 999999,
    };
    try {
      const response = await ApiService.GET_RESTAURANT(params, user.token.token);
      if (response?.payload?.records) {
        setRestaurants(response.payload.records);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      message.error("Failed to load categories");
    }
  };

  const options = restaurants.map((restaurant) => ({
    value: restaurant.restaurantId,
    label: restaurant.restaurantFullName,
  }));

  const handleChange = (values) => {
    const uniqueRestaurants = [
      ...new Map([...selectedRestaurants, ...options].map((item) => [item.value, item])).values(),
    ];
    let selected = uniqueRestaurants.filter((option) => values.includes(option.value));

    setSelectedRestaurants(selected);
  };

  const handleOk = () => {
    records.onFinish({
      showModal: false,
      param: {
        groupId: records.param.groupId,
        groupName: records.param.groupName,
        selectedRestaurants,
      },
    });
  };

  const handleCancel = () => {
    records.onCancel(); // Callback function
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={openModal}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col font-uregular">
          <div className="text-2xl font-ubold">View Group</div>
          <Divider />
          <div
            key={`category${records.param.order_id}`}
            className="flex flex-row mb-[16px]
                                    font-uregular py-[16px]
                                    rounded bg-white items-center"
          >
            <div className="flex flex-col items-end flex-grow">
              <div className="text-lg text-preblack font-ubold">{records.param.groupName}</div>
            </div>
          </div>
          {/* List of Restaurants */}
          <div className="flex flex-col">
            <p>Select Restaurants : </p>
            <div className="flex flex-row mb-[16px] font-uregular py-[16px] rounded bg-white items-center">
              <Space
                style={{
                  width: "100%",
                }}
                direction="vertical"
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="Please Select Restaurants"
                  onChange={handleChange}
                  options={options}
                  value={selectedRestaurants} // Controlled component
                  showSearch
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode} // Ensures dropdown is within modal
                />
              </Space>
            </div>
          </div>
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default ViewGroupModal;
